import { useEffect, useState } from "react";
import { Clock } from "@untitledui/icons";
import { countdownText } from "../lib/countdown";
import { type DateLike, formatJalali } from "../lib/jalali";
import { cx } from "../utils/cx";

export interface CountdownProps {
    /** When the money becomes available (end of the guarantee period). */
    target: DateLike;
    /** Fixed "now" (tests, stories). Omit to tick every minute. */
    now?: DateLike;
    /** Sentence prefix, default «قابل برداشت». */
    prefix?: string;
    icon?: boolean;
    className?: string;
}

/** «قابل برداشت در 9 روز دیگر», with the exact Jalali date in the tooltip title. */
export const Countdown = ({ target, now, prefix, icon = true, className }: CountdownProps) => {
    const [tick, setTick] = useState(() => Date.now());

    useEffect(() => {
        if (now !== undefined) return;
        const id = window.setInterval(() => setTick(Date.now()), 60_000);
        return () => window.clearInterval(id);
    }, [now]);

    return (
        <span className={cx("inline-flex items-center gap-1.5 text-sm text-tertiary", className)} title={formatJalali(target, "datetime")}>
            {icon && <Clock className="size-4 shrink-0 text-fg-quaternary" aria-hidden="true" />}
            {countdownText(target, now ?? tick, prefix)}
        </span>
    );
};
